<div class="bcg p-4 ">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat ms-1">
          <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>Wallet</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span class="clickable" [routerLink]="['/doqfy/wallet/payment-requests']">Payment Request</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span >Distribution</span>
         
        </p>
            </div>
      <div class="col-lg-3 col-sm-3 col-md-3 "></div>
      <div class="col-lg-3 col-sm-3 col-md-3 overlay text-right">
        <app-select-branch></app-select-branch>
      </div>
     </div>
     
     <div  class="card card_outLine mt-3">
         <div class="card-body">
             <div class="row">
                 <div class="col-lg-6 col-sm-6 col-md-6">
                     <h5 class="title_five">State wise Distribution</h5>
                     <p class="card-text text_p ">Amount Allocted as per State</p>
                 </div>
             <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
                <p-button label="Export Excel" (click)="export()" icon="bx bx-export"   styleClass="p-button-sm-outline"></p-button>
            <p-button class="ms-1" label="Back" [routerLink]="['/doqfy/wallet/payment-requests']"    styleClass="p-button-sm-outline"></p-button>
               
                          </div>
             </div>
                     </div>
       </div>
       <div  class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">Total Deposit : {{amountbalance}}</h5>
                </div>
              
                    <div class="col-lg-2 col-sm-2 col-md-2 form_inputFields_1">
                        <app-search-input placeholder="Search here"></app-search-input>
                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                        <app-dropdown  class="custom-dropdown text-left" [options]="states" [(ngModel)]="selectedState" (click)= getSelected() placeholder="Select State"  optionLabel="name"></app-dropdown>
        
                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 overlay">
                            <span>
                            <p-datepicker class="custom-calendar"[(ngModel)]="selectedDate" icon="bx bxs-calendar"  placeholder="Select Month" view="month" dateFormat="MM yy"
                            [showIcon]="true" iconDisplay="input" [readonlyInput]="false" inputId="monthpicker">
                               </p-datepicker>
                              </span>
                    </div>
            </div>
           
                <div class="row mt-2 mb-2 table_styleing" >
                  <form [formGroup]="addNewBalanceForm">
                  <table class="table table-borderless align-middle wallet_table">
                    <thead>
                      <tr>
                        <th scope="col">State Name</th>
                        <th scope="col">Allocated amount</th>
                        <th scope="col">Month</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    
                      <tbody formArrayName="allocateAmount">
                        <tr *ngFor="let balance of amountbalanceData">
                          <td>{{balance.stateName}}</td>
                          <td>₹ {{balance.allocatedAmount}}</td>
                          <td>{{balance.month}}</td>
                          <td>{{balance.status}}</td>
                        </tr>
                        <tr *ngFor="let details of allocateAmountArray().controls; let i = index" [formGroupName]="i" class="form_inputFields">
                          <td>
                            <input class="form-control edit_input" formControlName="stateName" placeholder="State Name" pInputText type="text">
                            <span class="p-error" *ngIf="submitted && allocateAmountArray().at(i).get('stateName')?.hasError('required')">Enter State Name</span>
                          </td>
                          <td>
                            <input class="form-control edit_input" formControlName="allocatedAmount" placeholder="Enter Amount to Allocate" pInputText type="text" (keypress)="numberOnly($event)">
                            <span class="p-error" *ngIf="submitted && allocateAmountArray().at(i).get('allocatedAmount')?.hasError('required')">Enter Amount</span>
                          </td>
                          <td>
                            <input class="form-control edit_input" formControlName="month" placeholder="Selected Month" pInputText type="text">
                            <span class="p-error" *ngIf="submitted && allocateAmountArray().at(i).get('month')?.hasError('required')">Enter Month</span>
                          </td>
                          <td class="remove_btn">
                            <p-button type="button" icon="pi pi-trash" (click)="removeDetails(i)" styleClass="p-button-sm-outline"></p-button>
                          </td>
                        </tr>
                      </tbody>
                  
                    <tfoot>
                      <tr>
                        <td class="overlay_Z_0">
                          <app-dropdown class="custom-dropdown text-left" [options]="states" formControlName="selectedStateName" placeholder="Select State" optionValue="value" optionLabel="name"></app-dropdown>
                        </td>
                        <td class="form_inputFields">
                          <input class="form-control edit_input" placeholder="Enter Amount to Allocate" formControlName="selectedAllocatedAmount" pInputText type="text" (keypress)="numberOnly($event)">
                        </td>
                        <td class="overlay">
                          <p-datepicker class="custom-calendar" formControlName="selectedMonth" placeholder="Select Month" view="month" dateFormat="MM" [showIcon]="true" iconDisplay="input" [readonlyInput]="false" inputId="monthpicker"></p-datepicker>
                        </td>
                        <td>--</td>
                      </tr>
                    </tfoot>
                  </table>
                </form>
                </div>
          

<div class="row">
    <div class="col-lg-2 col-sm-2 col-md-2">
        <p-button icon="pi pi-plus" label="Add more States" (click)="pushToTable()"  styleClass="p-button-sm"></p-button>
     </div>
     <div class="col-lg-8 col-sm-8 col-md-8"></div>
     <div class="col-lg-2 col-sm-2 col-md-2 text-right">
        <p-button label="Save"  styleClass="p-button-sm-outline"></p-button>
     </div>
</div>


<div>

</div>
                   
           
            </div>
        </div>
    

</div>